<script setup lang="ts">
import { computed } from 'vue'

/**
 * Loading spinner — a ring that inherits the current text color (`border-current`), so it shows
 * white inside a filled button and gray on a light surface. Consolidates the ad-hoc
 * `border-2 border-white border-t-transparent animate-spin` rings (auth submit buttons) and the
 * inline SVG spinners. Single-root <span> so margin/extra classes (e.g. `mr-2`) fall through.
 *
 * For a standalone icon-style spinner, Loader2 from lucide with `animate-spin` is also fine; this is
 * the border-ring variant used in buttons.
 */
interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg'
}
const props = withDefaults(defineProps<Props>(), { size: 'sm' })

const sizeClass = computed(
  () =>
    ({
      xs: 'h-3.5 w-3.5 border-2',
      sm: 'h-4 w-4 border-2',
      md: 'h-5 w-5 border-2',
      lg: 'h-6 w-6 border-[3px]',
    })[props.size],
)
</script>

<template>
  <span
    class="inline-block shrink-0 animate-spin rounded-full border-current border-t-transparent"
    :class="sizeClass"
    role="status"
    aria-label="Loading"
  />
</template>
